<div class="privacy-policy-page" *ngIf="previousPrivacyPolicy">
  <h1>{{ 'PRIVACY_POLICY.TITLE' | translate }}</h1>

  <section class="policy-section">
    <h3><strong>Care este scopul acestei Politici?</strong></h3>
    <p>Următoarele informații vă sunt furnizate pentru a vă informa despre categoriile de Date cu caracter personal care fac
    obiectul colectării și prelucrării atunci când utilizați site-uri web, portaluri, aplicații și platforme (&quot;Site-ul&quot; nostru sau
    &quot;Site-urile&quot;), modul în care noi (adică MyBenefits Digital) folosim aceste Date cu caracter personal și cu cine este
    posibil să le partajăm. Această politică descrie, de asemenea, drepturile dvs. și modul în care puteți lua legătura cu
    noi pentru a vă exercita aceste drepturi sau pentru a ne pune orice întrebări pe care le-ați putea avea cu privire la
    protecția datelor dvs. personale.</p>
    <p>My Benefits Digital construiește relații durabile cu clienții, partenerii și beneficiarii săi, bazate pe încredere reciprocă,
    asigurându-se că datele lor personale sunt în siguranță și rămân confidențiale, protectia datelor personale  fiind o
    prioritate absolută pentru MyBenefits Digital.</p>
    <p>MyBenefits Digital se angajează să respecte toate prevederile legale aplicabile care reglementează protecția datelor
    cu caracter personal.</p>
    <p>MyBenefits Digital aplică o politică de confidențialitate foarte strictă pentru a garanta protecția datelor personale ale
    celor care utilizează Site-urile sale:</p>
    <ul>
      <li>Utilizatorii păstrează controlul asupra propriilor date. Datele sunt prelucrate într -un mod transparent, confidențial și sigur.</li>
    </ul>
    <ul>
      <li>MyBenefits Digital se angajează să continue să protejeze datele personale ale utilizatorilor săi în
      conformitate cu Regulamentul general privind protecția datelor din 27 aprilie 2016 (GDPR) , cu Directiva E-Privacy 2002/58/CE din 12 iulie 2002 privind prelucrarea datelor personale și protejarea confidențialității în
      sectorul comunicațiilor publice Directiva asupra confidențialității și comunicațiilor electronice, cu
      Regulamentul European 2024 /1689 și bineînțeles în conformitate cu legile locale care transpun aceste
      prevederi Europene</li>
    </ul>
    <ul>
      <li>MyBenefits Digital are un Responsabil însărcinat cu Protecția Datelor dedicat prin Pluxee Romania SRL ca
      Operatori Asociați și ca entitate ce deține capitalul majoritar al MyBenefits Digital SRL , pe care îl puteți
      contacta în caz de nelămuriri la adresa dedicată: <strong>dpo.mybenefits.ro@pluxeegroup.com</strong></li>
    </ul>
    <p>Această politică poate fi modificată, completată sau actualizată, în special pentru a respecta orice evoluții legislative,
      de reglementare, jurisprudență sau tehnice care pot apărea. Cu toate acestea, datele dvs. personale vor fi
      întotdeauna prelucrate în conformitate cu politica în vigoare la momentul colectării datelor, cu excepția cazului în
      care o prevedere legală obligatorie stabilește o altă modalitate de prelucrare ce trebuie aplicată retroactiv.</p>
    <h3><strong>Cine este &quot;operatorul&quot; și cum puteți lua legătura cu noi?</strong></h3>
    <p>Operatorul:</p>
    <p>MYBENEFITS DIGITAL S.R.L.</p>
    <p>Iride Business Park - clădirea 19, camera 8, B -dul Dimitrie Pompei nr. 9 - 9A, sector 2, 020335, București, România,
    CUI RO46001730, avand nr. de înregistrare la Registrul Comerțului J2022007630400, reprezentată de Gabor Olajos și
    Florin Mototolea, în calitate de administratori</p>
    <p>Responsabilul cu protecția datelor: <strong>dpo.mybenefits.ro@pluxeegroup.com</strong></p>
    <p>De asemenea, fiind parte dintr-un grup de entități MyBenefits Digital va putea acționa împreună cu Pluxee România
    ca Operatori Asociați atunci când acționează în scopuri și mijloace comune pentru a vă putea oferi servicii de cea mai
    înaltă calitate, pentru a vă putea menține informați , pentru a vă putea facilita accesul la resurse și a ușura procesul
    de comandă și navigarea în platformele noastre.</p>
    <p>Datele Operatorului Asociat Pluxee România</p>
    <p>Sediul social în B-dul Dimitrie Pompei nr. 9 – 9A, Clădirea 19, Etaj 3, Sector 2, București, România, înregistrată la
    Registrul Comer țului Bucure ști sub nr. J40/9678/1998, Identificator Unic la nivel European (EUID):
    ROONRC.J40/9678/1998 și av ând codul unic de înregistrare (CUI) 11071295, reprezentat ă prin Gabor Olajos, în
    calitate  de Director General</p>
    <p>Responsabilul cu protecția datelor: <strong>privacy.ro@pluxeegroup.com</strong>.</p>
    <p>Puteți exercita oricând drepturile dumneavoastră GDPR contactând oricare dintre Operatorii indicați la adresele de
    mai sus.</p>
    <h3><strong>Definiții</strong></h3>
    <ul>
      <li>&quot;Operator&quot; - Înseamnă persoana fizică sau juridică, autoritate publică, agenție sau alt organism care, singură sau împreună cu alții, stabilește scopurile și mijloacele de prelucrare a datelor dvs. personale pe site-uri.</li>
    </ul>
    <ul>
      <li>Operator Asociat - Înseamnă persoana fizică sau juridică, autoritate publică, agenție sau alt organism care
      împreună cu alții, stabilește scopurile și mijloacele de prelucrare a datelor dvs. personale. My Benefits Digital
      operează în asociere cu Pluxee România care obține astfel calitatea de Operator Asociat întrucât cele două
      entități parte din același Grup stabilesc împreună scopurile și mijloacele prelucrării care sunt de asemenea
      comune.</li>
    </ul>
    <ul>
      <li>&quot;Date personale&quot; - Înseamnă orice informație referitoare la o persoană fizică identificată sau care poate fi
      identificată direct sau indirect prin referire la un număr de identificare sau la unul sau mai multe elemente
      specifice persoanei respective.</li>
    </ul>
    <ul>
      <li>Date Sensibile (categorii speciale de date) - Date care dezvăluie originea rasială sau etnică, opiniile politice,
      confesiunea religioasă sau convingerile filozofice, apartenența sindicală , date genetice, date biometrice
      pentru identificarea unică a unei persoane fizice, date privind sănătatea sau viața sexuală sau orientarea
      unei persoane fizice conform Art 9 (1) din Regulamentul General privind Protecția Datelor (2016/679).</li>
    </ul>
    <ul>
      <li>&quot;Prelucrare&quot; - Orice operațiune sau set de operațiuni care se efectuează cu privire la datele cu caracter
      personal, cu sau fără utilizarea de mijloace automatizate, cum ar fi colectarea, înregistrarea, organizarea,
      structurarea, stocarea, adaptarea sau modificarea, ex tragerea, consultarea, utilizarea, divulgarea prin
      transmitere, diseminarea sau punerea la dispoziție în orice alt mod, alinierea sau combinarea,
      restricționarea, ștergerea sau distrugerea.</li>
    </ul>
    <ul>
      <li>&quot;Persoană împuternicită&quot; - Persoana fizică sau juridică, autoritate publică, agenție sau alt organism care prelucrează datele cu caracter personal în numele operatorului de date.</li>
    </ul>
    <ul>
      <li>Consimțământ- Orice manifestare de voință liberă, specifică, informată și lipsită de ambiguitate a persoanei vizate prin care aceasta acceptă, printr-o declarație sau printr-o acțiune clară ca datele sale cu caracter personal să fie prelucrate.</li>
    </ul>
    <ul>
      <li>&quot;nouă&quot;, &quot;noi&quot; sau &quot;noastră&quot; - My Benefits Digital și asociații săi care acționează în calitate de operator.</li>
    </ul>
    <ul>
      <li>&quot;voi&quot; sau &quot;Utilizatorii&quot; - Orice utilizator / vizitator al Site-ului sau beneficiar al Serviciilor.</li>
    </ul>
    <p>Cum vor fi colectate datele dumneavoastră cu caracter personal? Este obligatoriu ca dvs. sau alte persoane să furnizați datele dvs. personale?</p>
    <p>Putem colecta datele dvs. personale în modurile enumerate mai jos:</p>
    <ul>
      <li>Colectarea Directă a datelor dvs. personale:</li>
      <ul>
        <li>Prin intermediul website-ului: când completați formulare de contact pe site-urile noastre, când solicitați o ofertă sau vă înscrieți pentru alte operațiuni;</li>
        <li>Platformă: prin înregistrarea contului de utilizator de către angajat</li>
      </ul>
    </ul>
    <ul>
      <li>Colectarea Indirectă a Datelor dvs. cu caracter personal:</li>
      <ul>
        <li>în timpul navigării pe Site sau prin intermediul furnizorilor noștri de servicii și / sau al tehnologiilor de pe Site-urile noastre.</li>
        <li>Indirect de la alte persoane juridice (de exemplu, angajatorul dvs.) în scopul executării contractelor, deschiderii conturilor de utilizator și utilizării serviciilor noastre, în baza unui temei legal (interes legitim, executare contract, consimțământ).</li>
        <li>Indirect de la autoritățile publice sau de reglementare în scopul identificării și solicitării de informații.
        <li>Indirect de la alți parteneri, pe baza consimțământului prealabil dat de dvs. pentru partajarea
        datelor cu caracter personal. Putem primi date de la parteneri cu care avem acorduri comerciale,
        cum ar fi și Pluxee România ca entitate asociată ca Operator, dar și de la alți parteneri cum ar fi
        furnizorii din Platformă, pe baza consimțământului acordat de persoana vizată pentru partajarea
        datelor între entități.</li>
        <li>Prin tehnologii web: putem colecta date prin intermediul tehnologiilor de pe site (cookie-uri, IP,
        Statistici de navigare, date tehnice despre dispozitiv) pentru a asigura funcționalitatea platformei,
        a analiza traficul și a oferi o experiență personalizată. Vă rugăm să consultați Politica de Cookie-uri
        pentru detalii. Orice cookie utilizat de către site-ul nostru care nu este absolut necesar pentru
        funcționalitatea site-ului va fi utilizat doar pe baza consimțământului dvs. prealabil și explicit.</li>
      </ul>
    </ul>

    <p>Vom colecta datele dvs. personale în mod obligatoriu, în cazul în care acest lucru este impus de legile locale aplicabile
    sau în cazul în care acest lucru este necesar pentru prestarea serviciilor de pe site  prin intermediul cookie-urilor
    mentionate sau ale formularelor de contact ori oferta pe care le accesați prin intermediul site-ului.</p>
    <p>Dacă nu putem colecta aceste elemente obligatorii pentru funcționarea site -ului sau a formularelor integrate în cadrul site-ului, nu vom putea gestiona accesul dvs. la Site.</p>
    <h3><strong>Ce date cu caracter personal deține My Benefits Digital? În ce scopuri și pe ce bază legală vor fi colectate și
    prelucrate datele dvs. personale?</strong></h3>
    <p>Putem prelucra, utiliza și dezvălui datele dvs. personale în anumite scopuri, așa cum este detaliat mai jos, legate de
    utilizarea de către dvs. a site-ului și de serviciile pe care le furnizăm sau pe baza relației cu My Benefits ori cu
    Partenerii sau Furnizorii noștri și a comenzilor solicitate.</p>
    <p>Vom colecta și prelucra datele dvs. personale așa cum este detaliat mai jos (fără ca această listă să fie exhaustivă,
    avand doar un rol exemplificativ) atunci când este necesar pentru a vă oferi acces la Site sau atunci când este necesar
    pentru respectarea unei obligații legale la care suntem supuși. Scopurile pot fi semnificativ mai restrânse pentru
    prelucrarea aplicabilă dvs. în funcție de opțiunile manifestate de dumneavoastră la înrolare  sau pot fi extinse cu
    scopuri adiționale caz în care vom actualiza lista de mai jos cu scopurile adiționale și cu respectarea condițiilor legale.</p>
    <p>De asemenea, vom colecta și prelucra datele dvs. personale pentru  interesele legitime ale MyBenefits Digital, cu
    excepția cazului în care aceste interese sunt înlăturate de interesele sau drepturile și libertățile dvs. fundamentale.
    În cazul în care interesele legitime nu se aplică ca bază legală pentru prelucrarea datelor cu caracter personal în
    conformitate cu legile aplicabile privind protecția datelor, consimțământul explicit prealabil va fi colectat alternativ,
    dacă acest lucru este cerut de lege.</p>

    <section class="policy-section">
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Categoria de persoane vizate</th>
              <th>Categorii de date prelucrate</th>
              <th>Temeiul Juridic</th>
              <th>Scopul prelucrării</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Utilizatori finali</td>
              <td>Nume, prenume, adresa e-mail,
                număr de telefon, companie,
                funcție, CNP, informații despre
                tranzacții și orice alte date pe
                care ni le veți pune la dispoziție
                în diferite scopuri prin diferite
                mijloace / formulare (de
                exemplu, pentru a face o
                solicitare, în scopuri de
                abonare, pentru a participa la
                sondaje, în scopuri de
                marketing, informative etc).
                Informațiile pe care le furnizați
                în scopuri de conectare, cum ar
                fi numele dvs., datele dvs. de
                contact (adresa de e-mail,
                adresa, numărul de telefon).

                Datele dvs. de navigare.
                Înregistrarea audio a apelurilor
                telefonice cu Call Center-ul Operatorului (Data apelului: zi,
                lună, an) și ora apelului (adică
                oră, minut, secundă); numărul
                de telefon și orice alte date
                furnizate în timpul apelului în
                vederea soluționării unei cereri
                / reclamații).
              </td>
              <td>
                Executarea contractului - pentru
                a oferi acces la beneficiile din
                platformă
                Interes Legitim- pentru a asigura
                buna funcționare a platformei și
                a preveni fraudele ori când
                MyBenefits are un interes
                legitim care nu contravine
                drepturilor persoanelor fizice
                indicate ca persoane de contact
                și înregistrează un beneficiu real
                prin prelucrare.
                Consimțământul - atunci când
                este necesar pentru comunicări
                de marketing și prezentarea
                celor mai noi oferte de care pot
                dispune.
                Obligație legală- Pentru
                prelucrarea anumitor date în
                cazuri speciale ori a unor
                categorii speciale de date (cum ar fi CNP ul) în cazuri specifice,
                dacă este necesar fie pentru
                furnizarea serviciilor, fie pentru
                îndeplinirea obligațiilor legale
              </td>
              <td>
                Asigurarea accesului la
                contul de utilizator si
                bugetele alocate,
                Managementul contului,
                Procesarea comenzilor și a
                tranzacțiilor,
                Furnizarea de beneficii,
                Comunicarea cu utilizatorii
                directă sau prin punerea la
                dispoziție a serviciilor de
                Call centre pentru
                soluționarea cererilor,
                notificări în privința
                modificărilor ori informări
                importante ori comerciale,
                Comunicări publicitare cu
                privire la oferte, promoții,
                campanii și concursuri ce
                ar putea prezenta un
                interes prin Colectarea si
                procesarea de date personale conform
                consimțământului acordat
                pentru partajarea cu
                parteneri de marketing sau
                furnizori ai unor platforme
                de marketing, inclusiv
                servicii de promovare pe
                rețelele de socializare,
                rețele de publicitate,
                furnizori de date terți și alți
                furnizori de servicii, pentru
                a atrage sau a înțelege mai
                bine utilizatorii și a le
                transmite comunicari cat
                mai relevante
                Pentru a furniza, livra și
                îmbunătăți serviciile și
                ofertele disponibile în
                aplicație
                Efectuarea analizei datelor
                și a analizei statistice
                pentru a monitoriza
                calitatea serviciilor
                noastre.
                Pentru a efectua analize și
                statistici avansate cu
                consimțământul dvs.
                prealabil (profilare,
                segmentare, analiză
                complexă a datelor pe baza
                proceselor de date) prin
                intermediul aplicației
                noastre. Mai exact, vom
                genera analize
                personalizate cu
                consimțământul dvs.
                prealabil pentru profilare și
                segmentare în scopuri de
                marketing pentru: oferte
                personalizate,
                îmbunătățirea serviciilor și
                a experienței utilizatorilor,
                personalizarea campaniilor
                de marketing.
              </td>
            </tr>
            <tr>
              <td>Reprezentan-ții
                legali/ Persoane
                de contact ale
                Clienților</td>
              <td>
                Nume, prenume, funcție,
                adresă de e-mail, număr
                telefon, companie și alte detalii
                care țin de viața profesională
              </td>
              <td>
                Executarea Contractului -
                pentru a stabili și menține relația
                contractuala cu Clientul, a
                asigura prestarea serviciilor
                conform contract, a asigura funcționarea platformei și a oferi
                comunicările esențiale, precum
                și pe cele comerciale referitoare
                la serviciile MyBenefits
                Interesul Legitim - atunci când
                din motive justificate MyBenefits
                are un interes legitim care nu
                contravine drepturilor
                persoanelor fizice indicate ca
                persoane de contact și
                înregistrează un beneficiu real
                prin prelucrare.
                Consimțământul- atunci când
                este necesar pentru: comunicări
                de marketing și prezentarea
                celor mai noi oferte de care pot
                dispune.
                Obligația legală - pentru
                îndeplinirea tuturor obligațiilor
                noastre impuse de lege în ceea
                ce privește impozite, taxe,
                organizarea sistemului de
                beneficii extrasalariale,
                răspundere, comenzi
              </td>
              <td>
                Administrarea contractului,
                comunicare,
                suport tehnic,
                comunicări oferte
                comerciale prin Colectarea si procesarea de date
                personale conform
                consimțământului acordat
                pentru partajarea cu
                parteneri de marketing sau
                furnizori ai unor platforme
                de marketing, inclusiv
                servicii de promovare pe
                rețelele de socializare,
                rețele de publicitate,
                furnizori de date terți și alți
                furnizori de servicii, pentru
                a atrage sau a înțelege mai
                bine utilizatorii și a le
                transmite comunicari cât
                mai relevante,
                concursuri,
                Raportări legale, taxe,
                efectuarea și finalizarea
                comenzilor, înregistrări.
              </td>
            </tr>
            <tr>
              <td>
                Persoanele fizice
                care acționează
                ca reprezentanți
                ai partenerilor
                furnizori
              </td>
              <td>
                Nume, prenume, funcție, email, număr de telefon,
                companie, precum și orice alte
                detalii profesionale necesare
                Date din surse publice în
                virtutea calităților profesionale
                deținute
              </td>
              <td>
                Executarea contractului –
                încheiat cu furnizorii noștri
                pentru diferite produse / servicii
                Interes Legitim- atunci când din
                motive justificate MyBenefits are
                un interes legitim care nu
                contravine drepturilor
                persoanelor fizice indicate ca
                persoane de contact și
                înregistrează un beneficiu real
                prin prelucrare.
                Consimțământul - atunci când
                este necesar pentru comunicări
                de marketing și prezentarea
                celor mai noi oferte de care pot
                dispune
                Obligația legală - pentru
                îndeplinirea tuturor obligațiilor
                noastre impuse de lege în ceea
                ce privește impozite, taxe,
                organizarea sistemului de
                beneficii extrasalariale,
                răspundere, comenzi
              </td>
              <td>
                Pentru managementul
                parteneriatului
                contractual, procesare
                plăți,
                Interesul legitim de a
                interacționa cu Partenerii,
                Scopuri de conversie,
                Scopuri comerciale prin
                Colectarea și procesarea
                de date personale conform
                consimțământului acordat
                pentru partajarea cu
                parteneri de marketing sau
                furnizori ai unor platforme
                de marketing, inclusiv
                servicii de promovare pe
                rețelele de socializare,
                rețele de publicitate,
                furnizori de date terți și alți
                furnizori de servicii, pentru
                a atrage sau a înțelege mai
                bine utilizatorii și a le
                transmite comunicari cât
                mai relevante, Răspundere legală și
                contractuală,
                Comunicare Operațională
                și Comercială
              </td>
            </tr>
            <tr>
              <td>
                Participanți /
                Câștigători ai
                campaniilor /
                Concursuri
                organizate de
                MyBenefits și /
                sau Operatorul
                Asociat (Pluxee)
              </td>
              <td>
                Datele necesare conform
                Regulamentelor Publicate
                precum nume, prenume,
                adresă e-mail, conturi bancare
                și datele specifice concursului
                organizat pentru a putea
                asigura desfășurarea sa și
                înmânarea premiilor
              </td>
              <td>
                Consimțământul persoanei
                vizate de a participa la campanie
                / Concursul organizat de
                MyBenefits sau Operatorii
                Asociați dacă scopul și mijloacele
                sunt comune, precum și
                consimțământul privind
                transferul către diverși furnizori
                implicați in organizarea
                concursului (Ex: agenții de
                marketing, turism, foto, etc.) ori
                pentru primirea de comunicări
                comerciale ulterioare
                Interesul Legitim al
                Operatorului/ilor de a crește
                interacțiunea cu Business-ul
                Obligația legală a
                Operatorului/ilor de a-și exercita
                și apăra diverse pretenții acțiuni
                în fața instanțelor judecătorești,
                autorități, instituții publice și
                alte persoane după caz.
              </td>
              <td>
                Campania / concursul
                derulat de Operator.
                Promovarea ofertelor
                proprii.
                Validarea câștigătorilor și
                Acordarea premiilor
                Transmiterea de oferte
                comerciale ulterioare prin
                Colectarea si procesarea
                de date personale conform
                consimtamantului acordat
                pentru partajarea cu
                parteneri de marketing sau
                furnizori ai unor platforme
                de marketing, inclusiv
                servicii de promovare pe
                rețelele de socializare,
                rețele de publicitate,
                furnizori de date terți și alți
                furnizori de servicii, pentru
                a atrage sau a înțelege mai
                bine utilizatorii și a le
                transmite comunicari cât
                mai relevante.
                Apărarea drepturilor
                Operatorului și inițierea
                procedurilor legale în fața
                oricărei instanțe de
                judecată, autorități sau
                instituții publice sau a
                oricărei alte entități
                conform legii.
                Plata impozitelor și a altor
                obligații conform legii,
                atunci când este cazul.
                Soluționarea reclamațiilor
                legate de desfășurarea
                campaniei / concursului.
              </td>
            </tr>
            <tr>
              <td>
                Utilizatori și
                Vizitatori
                Website și
                Platformă
                MyBenefits
                Digital și Pagina dedicată în
                platforma
                detinuta de
                Pluxee
              </td>
              <td>
                Adresa IP
                Modulele Cookie
                Date statistice agregate
                Date despre parcursul și
                navigarea pe website precum
                PII-Date de identificare (nume, prenume, imagine) dacă ați
                furnizat aceste date în diferite
                formulare completate sau date
                tehnice (ora și data conectării,
                metadate)
              </td>
              <td>
                Consimțământ - întotdeauna vă
                vom solicita consimțământul
                atunci când dorim să prelucram
                date despre dumneavoastră ori
                preferințele dumneavoastră captate prin intermediul website
                ului sau plasarea de cookies.
                Interesul legitim – pentru a
                putea implementa măsurile
                tehnice necesare pentru
                funcționarea site-ului nostru
                web
              </td>
              <td>
                Personalizarea site-ului /
                platformei web și
                îmbunătățirea experienței
                dvs. de utilizator.
                O descriere mai detaliată a
                modului și motivului pentru care am putea
                utiliza cookie-urile pe
                diferite pagini ale
                platformei / pe website
                este disponibilă în Politica
                de Cookies disponibilă pe
                website.
              </td>
            </tr>
            <tr><th colspan="4">Datele dvs. vor putea fi utilizate în orice alt scop pe care îl vom specifica la momentul colectării sau cel mai târziu
              concomitent cu prelucrarea și il vom descrie în politica de confidențialitate specifică.</th></tr>
          </tbody>
        </table>
      </div>
    </section>

    <h3><strong>Cine va avea acces la datele dumneavoastră cu caracter personal?</strong></h3>
    <p>MyBenefits Digital face parte dintr-un grup sub brandul Pluxee ("grupul Pluxee"), din cadrul căruia compania Pluxee
      România deține capitalul majoritar și acționariatul asupra MyBenefits Digital.</p>
    <p>Astfel, MyBenefits Digital și Pluxee România au scopuri și mijloace comune de prelucrare a datelor dumneavoastră
      între acestea existând un Acord de prelucrare în comun.</p>
    <p>Există posibilitatea transferurilor datelor dvs. personale în interiorul sau în afara grupului Pluxee după cum este
      detaliat mai jos:</p>
    <ul>
      <li>În cadrul Grupului Pluxee</li>
    </ul>
    <p>Securitatea și confidențialitatea datelor dvs. personale sunt de mare importanță pentru noi și pentru celelalte entități
      ale grupului Pluxee din care MyBenefits Digital face parte. Acesta este motivul pentru care restricționăm accesul la
      datele dvs. personale doar pentru membrii desemnați din personalul nostru și numai în măsura strict necesară
      conform principiului nevoii de a cunoaste pentru a prelucra datele dvs. personale sau pentru a furniza serviciile
      necesare site-ului și platformei. Ne asigurăm că persoanele autorizate să prelucreze datele cu caracter personal din
      partea MyBenefits sau Pluxee România, în funcție de necesitate si activitate, vor respecta confidențialitatea și
      respectă obligația legală corelativă de confidențialitate.
      Legile europene privind protecția datelor nu permit transferul datelor cu caracter personal către țări terțe din afara
      Spațiului Economic European ("SEE") care nu asigură un nivel de securitate considerat adecvat de protecție a datelor
      de catre CE. Unele dintre țările terțe în care operează entitățile Pluxee sunt situate în afara SEE și nu oferă același
      nivel de protecție a datelor ca țara în care locuiți și nu sunt recunoscute de Comisia Europeană ca oferind un nivel
      adecvat de protecție a dreptului persoanelor fizice la confidențialitatea datelor pentru aceste transferuri, MyBenefits
      Digital, Pluxee România și entitățile Grupului Pluxee au implementat măsurile de protecție adecvate în conformitate
      cu legile și regulile relevante privind protecția datelor. Dacă aveți întrebări sau doriți să aveți detalii cu privire la aceste
      garanții, puteți contacta responsabilul cu protecția datelor, trimițând un e-mail la
      <strong>dpo.mybenefits.ro@pluxeegroup.com</strong> sau la adresa <strong>privacy.ro@pluxeegroup.com</strong></p>
    <ul>
      <li>În afara Grupului</li>
    </ul>
    <p>Nu vom dezvălui datele dvs. personale niciunei terțe părți neautorizate. Cu toate acestea, putem partaja datele dvs.
      personale cu furnizori de servicii autorizați (de exemplu, furnizori de produse, vouchere, servicii tehnice [găzduire, întreținere], consultanți etc.) la care putem apela în scopurile exemplificate mai sus, în conformitate cu legile
      aplicabile privind protecția datelor.</p>
    <p>Toți furnizorii terți de servicii cărora le dezvăluit și către care transferăm datele dvs. personale au fost angajați în baza
      unui acord obligatoriu de confidențialitate și prelucrare a datelor cu MyBenefits Digital, cu Pluxee România sau cu
      Grupul Pluxee, prin care respectiva terță parte poate acționa numai în baza instrucțiunilor entităților MyBenefits
      Digital, Pluxee România sau ale Grupului Pluxee.</p>
    <p>Acesti furnizori terți de servicii și / sau alți contractanți, după caz, pot fi localizați în țări terțe (de exemplu, Statele
      Unite, Regatul Unit), unde legile privind protecția datelor nu pot oferi un nivel de protecție echivalent cu legislația
      europeană (menționăm faptul că Comisia Europeană a recunoscut Statele Unite și Regatul Unit ca oferind o protecție
      adecvată). Dacă entitățile Pluxee Romania sau ale grupului Pluxee dezvăluie datele dvs. personale unor astfel de
      destinatari, care vor fi numai în scopuri definite în cazuri extreme sau în scopul furnizării de asistență la cererea
      noastră, vom stabili și / sau confirma că, înainte de a primi oricare dintre datele dvs. personale, acestea vor oferi un
      nivel adecvat de protecție pentru datele dvs. personale, inclusiv măsuri de securitate tehnice și organizatorice
      adecvate. În special, dacă destinatarii în cauză se află într-o țară care nu oferă un nivel adecvat de protecție, vom
      implementa, de asemenea, alte măsuri adecvate, inclusiv clauze contractuale standard, pentru a asigura un astfel de
      transfer în conformitate cu legislația aplicabilă.
      Dacă aveți întrebări sau doriți să aveți detalii cu privire la aceste garanții, puteți contacta responsabilul cu protecția
      datelor din România, trimițând un e-mail la <strong>dpo.mybenefits.ro@pluxeegroup.com</strong> sau lacom sau la
      <strong>privacy.ro@pluxeegroup.com</strong>.</p>
    <p>În plus, putem partaja datele dvs. personale (i) dacă legea sau o procedură legală ne impune să facem acest lucru, (ii)
      ca răspuns la o solicitare din partea autorităților publice sau a altor funcționari sau (iii) dacă suntem de părere că
      transferul acestor date ar putea fi necesar sau adecvat pentru a preveni orice prejudiciu fizic sau pierdere financiară,
      sau în legătură cu o investigație privind o activitate ilegală suspectată sau dovedită.</p>
    <h3><strong>Cât timp vor fi păstrate datele dumneavoastră cu caracter personal?</strong></h3>
    <p>Vom stoca datele dvs. personale de-a lungul perioadei necesare pentru a îndeplini scopurile pentru care au fost
      colectate și prelucrate. Această perioadă poate fi prelungită, dacă este cazul, pentru orice perioadă de timp prevăzută
      de orice dispoziții legale sau de reglementare care se pot aplica.</p>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Categorii de date cu caracter
              personal</th>
            <th>Scopuri</th>
            <th>Perioada de stocare</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>In ceea ce priveste WEBSITE-ul /
              Aplicația:
              • Adresă IP
              • Date statistice
              • Modulele cookie
              • Date de identificare
              (nume, prenume,
              imagine - dacă le-ați
              furnizat)
              • Date tehnice (ora și
              data conectării,
              metadate)</th>
            <th>
              Personalizarea Site-ului și
              îmbunătățirea experienței.
              Respectarea obligațiilor legale
            </th>
            <th>Datele legate de utilizarea de către dvs. a
              Site-ului vor fi stocate de-a lungul
              perioadei necesare pentru Prelucrare.
              Maximum 13 luni (în funcție de categoria
              din care face parte cookie-ul). Pentru mai
              multe detalii, vă rugăm să consultați
              Politica privind cookie-urile.
              Perioada necesară pentru prelucrare.</th>
          </tr>
          <tr>
            <th>Adresa de e-mail
              Nume, Prenume, CNP
              Produse Utilizare, date despre
              tranzacții
              Orice date furnizate de utilizatori
              în cererea lor</th>
            <th>Colectarea și procesarea
              solicitărilor de la Utilizatorii care
              contactează MyBenefits Digital
              sau Pluxee prin intermediul call
              center-ului comun</th>
            <th>Perioada necesară pentru procesarea
              solicitării dvs.
              Perioada necesară pentru prelucrare care
              în general este de 5 ani de la ultima
              tranzacție, termen ce va putea suferi
              modificări în funție de obligații legale ce
              ar putea interveni în cazul individual
              analizat.
              Orice perioadă impusă de lege pentru
              documentarea și soluționarea unor
              reclamații ori plângeri legale.</th>
          </tr>
          <tr>
            <th>Date ce pot conduce la
              identificare (eg: IP)</th>
            <th>Permite investitorilor să
              acceseze platforma și să
              compileze statistici de
              monitorizare a publicului</th>
            <th>Perioada necesară în caz de prelucrare</th>
          </tr>
          <tr>
            <th>Orice altă categorie de date cu
              caracter personal determinată la
              momentul colectării și descrisă
              în politica de confidențialitate</th>
            <th>Orice alt scop specificat la
              momentul colectării și descris în
              politica de confidențialitate</th>
            <th>Perioada necesară pentru prelucrare
              raportată la scopul specific cu privire la
              care vă vom menține informați</th>
          </tr>
        </tbody>
      </table>
    </div>
    <p>Perioadele specifice de păstrare asociate fiecărui scop sunt enumerate în tabelul de mai sus.</p>
    <p>În cele din urmă vă rugăm să rețineți că putem anonimiza datele dvs. personale în așa fel încât să nu mai puteți fi
      identificat și să continuăm să le utilizăm în scopuri statistice. Datele prelucrate în scopuri statistice nu mai sunt
      clasificate ca date cu caracter personal odată ce au fost anonimizate în mod corespunzător.</p>
    <h3><strong>Datele dvs. personale sensibile vor fi prelucrate?</strong></h3>
    <p>Ca regulă generală, nu colectăm date personale sensibile (conform art.9 din GDPR) prin intermediul site-ului nostru
      sau pentru a furniza serviciile noastre. Vă rugăm să rețineți că formularele noastre de contact nu sunt destinate
      colectării de date personale sensibile. Prin urmare, ar trebui să vă limitați contribuția la ceea ce este strict necesar
      cu privire la solicitarea dvs. atunci când ne trimiteți un e-mail, ne contactați printr-un formular de contact sau prin
      orice alt mijloc.</p>
    <p>Datele cu caracter personal sensibile se referă la orice informații privind originea rasială sau etnică a unei persoane,
      opiniile politice, convingerile religioase sau filozofice, apartenența la sindicate, datele privind sănătatea sau datele
      referitoare la viața sexuală sau orientarea sexuală a unei persoane fizice. Această definiție include, de asemenea,
      date cu caracter personal referitoare la condamnări penale și infracțiuni, astfel cum sunt ele prevăzute de art. 9 GDPR.</p>
    <p>În cazul excepțional în care ar fi strict necesar să colectăm astfel de date pentru a atinge scopul pentru care se
      efectuează prelucrarea sau dacă ne furnizați astfel de date, de exemplu atunci când ne trimiteți un e-mail, vom
      prelucra aceste date în conformitate cu cerințele legale locale pentru protecția datelor cu caracter personal și, în
      special, cu acordul dvs. prealabil explicit și în condițiile descrise în această politică. </p>
    <h3><strong>Care sunt drepturile dvs. în legătură cu datele dvs. personale și cum vă puteți exercita aceste drepturi?</strong></h3>
    <p>Este important ca datele personale pe care le deținem despre dvs. să fie corecte și actuale. Vă rugăm să ne informați
      dacă datele dvs. personale se modifică prin actualizarea contului dvs. pe site imediat ce acestea suferă modificări.</p>
    <p>Ne angajăm să asigurăm protecția drepturilor dumneavoastră în conformitate cu legile aplicabile. Veți găsi mai jos un
      tabel care rezumă drepturile dvs. de confidențialitate în conformitate cu legea aplicabilă privind protecția datelor,
      care se aplică tuturor datelor cu caracter personal prelucrate pe Site.</p>
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Drepturi</th>
            <th>Descrierea drepturilor dumneavoastră</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>Dreptul de acces și
              rectificare</th>
            <th>Puteți obține toate informațiile enumerate în art. 15 GDPR și / sau puteți solicita o copie
              a datelor personale pe care le deținem despre dvs. De asemenea, puteți solicita
              rectificarea datelor cu caracter personal inexacte sau incomplete conform art. 16 GDPR.</th>
          </tr>
          <tr>
            <th>Dreptul la ștergere</th>
            <th>Dreptul dvs. de a fi uitat vă dă dreptul să solicitați ștergerea datelor dvs. personale în
              cazurile în care:
              • datele nu mai sunt necesare scopului pentru care au fost colectate;
              • alegeți să vă retrageți consimțământul;
              • vă opuneți prelucrării datelor dvs. personale;
              • datele dvs. personale au fost prelucrate ilegal;
              • există o obligație legală de a șterge datele dvs. personale.</th>
          </tr>
          <tr>
            <th>Dreptul la
              restricționarea
              prelucrării</th>
            <th>Puteți solicita restricționarea prelucrării datelor dvs. personale în cazurile în care:
              • contestați exactitatea datelor dvs. personale;
              • nu mai avem nevoie de datele dvs. personale în scopul prelucrării;
              • v-ați opus prelucrării din motive legitime;
              • prelucrarea datelor dvs. personale este ilegală și preferați restricționarea
              utilizării acestora în locul ștergerii lor.</th>
          </tr>
          <tr>
            <th>Dreptul la
              portabilitatea
              datelor</th>
            <th>Puteți solicita, dacă este cazul, portabilitatea datelor dvs. personale pe care ni le-ați
              furnizat, într-un format structurat, utilizat în mod obișnuit și care poate fi citit automat.
              Aveți dreptul să transmiteți aceste date altui operator fără obstacole din partea noastră
              în cazul în care:
              • prelucrarea datelor dvs. personale se bazează pe consimțământul dvs. sau pe
              un contract; și
              • prelucrarea se efectuează prin mijloace automate.
              De asemenea, puteți solicita ca datele dvs. personale să fie transmise unei terțe părți la
              alegere (acolo unde este fezabil din punct de vedere tehnic).</th>
          </tr>
          <tr>
            <th>Dreptul de a vă
              opune prelucrării</th>
            <th>Puteți obiecta (adică vă puteți exercita dreptul de "retragere") la prelucrarea datelor
              dvs. personale, în special în ceea ce privește profilarea sau comunicările de marketing. Când prelucrăm datele dvs. personale pe baza consimțământului dvs., vă puteți retrage
              consimțământul în orice moment.</th>
          </tr>
          <tr>
            <th>Dreptul de a nu fi
              supus unor decizii
              automatizate</th>
            <th>Aveți dreptul de a nu face obiectul unei decizii bazate exclusiv pe prelucrarea automată,
              inclusiv crearea de profiluri, care are un efect juridic asupra dvs. sau vă afectează în mod
              semnificativ.</th>
          </tr>
          <tr>
            <th>Dreptul de a depune
              o plângere</th>
            <th>Puteți alege să depuneți o plângere la Autoritatea de Supraveghere din România
              (ANSPDCP: http://www.dataprotection.ro)
              De asemenea, aveți dreptul de a depune plângerea în fața instanțelor române.</th>
          </tr>
          <tr>
            <th>Dreptul de retragere
              a consimțământului</th>
            <th>În situațiile în care este posibil să vă fi dat consimțământul specific pentru colectarea,
              prelucrarea și transferul informațiilor dvs. personale pentru un anumit scop, aveți
              dreptul să vă retrageți consimțământul pentru acea prelucrare specifică în orice
              moment. Când vă dați consimțământul, vi se va oferi în mod obișnuit metoda de a-l
              retrage. Odată ce am primit notificarea că v-ați retras consimțământul, nu vom mai
              procesa informațiile dvs. în scopul sau scopurile cu care ați fost de acord inițial, cu
              excepția cazului în care avem o altă bază legitimă pentru a face acest lucru în lege. Vă
              rugăm să aveți în vedere că dezabonarea va fi implementată în cel mai scurt timp posibil
              din perspectivă tehnică și umană.</th>
          </tr>
        </tbody>
      </table>
    </div>

    <p><strong>Pentru a vă exercita aceste drepturi, puteți:</strong></p>
    <ul>
      <li>să utilizați formularul web online de solicitare: Acest sistem electronic vă permite să vă conectați și să vedeți
        progresul solicitării dvs., să vedeți și să trimiteți mesaje și să vă revizuiți documentele în siguranță.</li>
      <li>De asemenea, puteți adresa întrebări sau reclamații Responsabilului cu protecția datelor, prin e-mail la
        <strong>dpo.mybenefits.ro@pluxeegroup.com</strong> sau prin poștă la adresa Blvd. Dimitrie Pompei nr. 9-9A, Iride Business
        Park Building, Etaj 3, Cam.8, Sector 2, București, România.</li>
    </ul>

    <p><strong>De obicei, nu este necesară nicio taxă</strong></p>
    <p>Nu va trebui să plătiți o taxă pentru a vă accesa datele personale (sau pentru a vă exercita oricare dintre celelalte
      drepturi). Cu toate acestea, este posibil să percepem o taxă rezonabilă dacă solicitarea dvs. de acces este în mod clar
      nefondată sau excesivă. Alternativ, putem refuza să dăm curs solicitării în astfel de circumstanțe.</p>

    <p><strong>Ce am putea avea nevoie de la dvs.</strong></p>
    <p>Este posibil să fie necesar să vă solicităm informații specifice pentru a ne ajuta să vă confirmăm identitatea și să vă
      asigurăm dreptul de a accesa informațiile (sau de a vă exercita oricare dintre celelalte drepturi). Aceasta este o altă
      măsură de securitate adecvată pentru a se asigura că datele cu caracter personal nu sunt divulgate niciunei persoane
      care nu are dreptul să le primească.
      Pentru mai multe detalii, vă rugăm să consultați Politica de tratare a solicitărilor și reclamațiilor privind
      protecția datelor cu caracter personal disponibila pe website.</p>

    <p><strong>Cum vor fi protejate datele dumneavoastră cu caracter personal?</strong></p>
    <p>Implementăm toate măsurile de securitate tehnice și organizaționale posibile pentru a asigura securitatea și
      confidențialitatea în prelucrarea datelor dvs. personale.</p>
    <p>În acest scop, luăm toate măsurile de precauție necesare, având în vedere natura datelor cu caracter personal și
      riscurile legate de prelucrarea acestora, pentru a menține securitatea datelor și, în special, pentru a preveni
      denaturarea, deteriorarea sau accesul neautorizat al terților (protecția fizică a spațiilor, proceduri de autentificare cu
      acces personal, securizat prin identificatori și parole confidențiale, un jurnal de conectare, criptarea anumitor date
      etc.)</p>
    <p>În plus, dacă încheiem un contract cu persoane împuternicite, cât și cu Operatori asociați pentru prelucrarea integrală
      sau parțială a datelor dvs. personale, avem nevoie de un acord contractual pentru a garanta securitatea și
      confidențialitatea datelor personale pe care le transmitem acestora sau pe care le colectează în numele nostru, în
      conformitate cu reglementările aplicabile privind protecția datelor cu caracter personal.</p>
    <p>Efectuăm în mod regulat audituri pentru a verifica aplicarea operațională corectă a regulilor referitoare la securitatea
      datelor dvs. personale.</p>
    <p>Cu toate acestea, aveți, de asemenea, responsabilitatea de a asigura securitatea și confidențialitatea datelor dvs.
      personale, așa că vă invităm să rămâneți vigilenți, mai ales atunci când utilizați un sistem deschis, cum ar fi Internetul.</p>

    <h3><strong>Link-uri către alte site-uri / platforme</strong></h3>
    <p>Ocazional, oferim link-uri către alte platforme în scopuri practice și informative. Aceste platforme funcționează
      independent de Site-urile noastre și nu se află sub controlul nostru. Aceste platforme au propriile politici de
      confidențialitate sau termeni de utilizare, pe care vă sfătuim cu tărie să le citiți. Nu ne asumăm nicio răspundere cu
      privire la conținutul de pe aceste platforme, pentru produsele și serviciile care pot fi oferite acolo sau pentru orice
      altă utilizare a acestora.</p>

    <h3><strong>Cum veți fi notificat dacă utilizările datelor dvs. personale se schimbă?</strong></h3>
    <p>Putem actualiza sau modifica această politică după cum și când este necesar. În acest caz, modificările vor deveni
      aplicabile numai după o perioadă de 30 de zile lucrătoare de la data modificării. Vă rugăm să consultați această pagină
      ocazional dacă doriți să fiți informat cu privire la orice modificări posibile.
      Dacă aveți întrebări sau comentarii cu privire la această politică, vă rugăm să nu ezitați să ne contactați la următoarea
      adresă: dpo.mybenefits.ro@pluxeegroup.com</p>

    <div class="meta">
      <p><strong>Aplicabilă începând de la:</strong> 26.08.2026</p>
      <p *ngIf="previousPrivacyPolicy">
        <a [href]="previousPrivacyPolicy" target="_blank" rel="noopener noreferrer">Versiune anterioară valabilă de la data de 29.01.2026</a>
      </p>
    </div>

  </section>
</div>
